import { mapState, mapGetters, mapActions } from 'vuex'

export const memberEditComputed = {
  ...mapState('memberEdit', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('memberEdit', ['getMemberDetails', 'getStatus', 'getError']),
}

export const memberEditMethods = mapActions('memberEdit', [
  'fetchingMemberDetails',
  'editMember',
  'resetMemberEdit',
])
